import { BaseSkeleton } from 'components/BaseSkeleton'

export const NicheCardListSkeleton = () => {
  return (
    <div className="NicheCardListSkeleton">
      <BaseSkeleton height="70px" width="100%" borderRadius="12px" />
      <BaseSkeleton height="70px" width="100%" borderRadius="12px" />
      <BaseSkeleton height="70px" width="100%" borderRadius="12px" />
      <BaseSkeleton height="70px" width="100%" borderRadius="12px" />
      <BaseSkeleton height="70px" width="100%" borderRadius="12px" />
      <BaseSkeleton height="70px" width="100%" borderRadius="12px" />
      <BaseSkeleton height="70px" width="100%" borderRadius="12px" />
      <BaseSkeleton height="70px" width="100%" borderRadius="12px" />
    </div>
  )
}
